'use client'

import UIChip from '@components/ui/UIChip'
import UIFlex from '@components/ui/UIFlex'
import UILink from '@components/ui/UILink'
import { pxToRem } from '@ui/style/muiTheme'

export interface TagListProps {
	tagList?: Array<string | null> | null
}
const TagList = ({ tagList }: TagListProps) => {
	return (
		<UIFlex
			flexDirection="row"
			mb={pxToRem(-8)}
			sx={{
				flexWrap: 'wrap',
				'&>*:not(:last-child)': {
					marginRight: pxToRem(8),
				},
				'&>*': {
					marginBottom: pxToRem(8),
				},
			}}
		>
			{(tagList?.filter((tag) => !!tag) as Array<string>)?.map((tag: string) => (
				<UIChip
					slotProps={{
						action: {
							component: UILink,
							href: `/search?keyword=${encodeURIComponent(tag)}`,
						},
					}}
					key={`tag-${tag}`}
				>
					{tag}
				</UIChip>
			))}
		</UIFlex>
	)
}

export default TagList
